import { useMemo } from 'react';
import { di } from 'react-magnetic-di';
import { ProfileClient } from '@atlaskit/profilecard';
var DIRECTORY_URL = '/gateway/api/directory/graphql';
var client;
export var useProfileClient = function useProfileClient() {
  var profileClient = useMemo(function () {
    if (!client) {
      // To support di
      client = new ProfileClient({
        url: DIRECTORY_URL,
        cacheSize: 1000,
        // 1 day
        cacheMaxAge: 1000 * 60 * 60 * 24
      });
    }
    return client;
  }, []);
  return profileClient;
};